import {
  BimfaceSDKLoader,
  BimfaceSDKLoaderConfig,
  Glodon
} from 'bimfacesdkloader';
import loadBimFaceComponent from './loadBimFaceComponent';

let app, viewer, drawableContainer;

// 加载模型
const loadModel = (viewToken, domElement) => {
  const config = new BimfaceSDKLoaderConfig();
  config.viewToken = viewToken;
  BimfaceSDKLoader.load(config).then(() => {
    // 获取DOM元素
    let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
    webAppConfig.domElement = domElement;
    // 创建WebApplication
    app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
    // 从WebApplication获取viewer3D对象
    viewer = app.getViewer();
    // 添加待显示的模型
    viewer.loadModel({
      viewToken: viewToken
    });
    //外部标签的容器
    let drawableContainerConfig = new Glodon.Bimface.Plugins.Drawable.DrawableContainerConfig();
    drawableContainerConfig.viewer = viewer;
    drawableContainer = new Glodon.Bimface.Plugins.Drawable.DrawableContainer(drawableContainerConfig);
    //禁用右键
    webAppConfig.enableToggleContextMenuDisplay = false;
    //光照
    webAppConfig.enableIBLBackground = true;
    webAppConfig.loadIBLScene = {
      IBLSceneOption: "ParkingLot"
    }
    //背景色
    viewer.setBackgroundColor(new Glodon.Web.Graphics.Color('#0b1547'));
    window.viewer = viewer;
  });
}

//添加组件
const addComponent = (position, labe_list) => {
  drawableContainer.clear()
  let customItemConfig = new Glodon.Bimface.Plugins.Drawable.CustomItemConfig();
  const container = document.createElement('div');
  const div = document.createElement('div');
  container.appendChild(div);
  customItemConfig.content = container;
  customItemConfig.worldPosition = position;
  customItemConfig.opacity = 0.8;
  let customItem = new Glodon.Bimface.Plugins.Drawable.CustomItem(customItemConfig);
  drawableContainer.addItem(customItem);
  let props = {
    labe_list: labe_list
  }
  loadBimFaceComponent(div, props);
}

// 销毁场景
const destroyViewer = () => {
  app && app.destroy();
}

export {
  loadModel,
  addComponent,
  destroyViewer
};
